var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "searchBox" },
        [
          _c(
            "el-form",
            {
              ref: "searchForm",
              attrs: { inline: false, "label-position": "top" },
              model: {
                value: _vm.queryForm,
                callback: function ($$v) {
                  _vm.queryForm = $$v
                },
                expression: "queryForm",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("navbar.cargoOrderStatus") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("GlobalSetObj.all"),
                                clearable: "",
                                filterable: "",
                                multiple: "",
                                size: "small",
                              },
                              model: {
                                value: _vm.queryForm.params.cargoOrderStatus,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "cargoOrderStatus",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.cargoOrderStatus",
                              },
                            },
                            _vm._l(_vm.waybillStatusList, function (item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: { label: item.label, value: item.code },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("newOrder.CustomerName") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "spareNumberPoo.Only10AreDisplayed"
                                ),
                                "remote-method": _vm.getCustomerPage,
                                clearable: "",
                                filterable: "",
                                remote: "",
                                "reserve-keyword": "",
                                size: "small",
                              },
                              on: {
                                focus: function ($event) {
                                  return _vm.getCustomerPage("")
                                },
                              },
                              model: {
                                value: _vm.queryForm.params.customerId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "customerId",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.customerId",
                              },
                            },
                            _vm._l(_vm.customerList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label:
                                    item.customerAlias +
                                    "(" +
                                    item.username +
                                    ")",
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("navbar.senderState") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                                size: "small",
                              },
                              model: {
                                value: _vm.queryForm.params.senderState,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "senderState",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.senderState",
                              },
                            },
                            _vm._l(_vm.StateList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.label, value: item.label },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("navbar.receiveState") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                                size: "small",
                              },
                              model: {
                                value: _vm.queryForm.params.receiveState,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "receiveState",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.receiveState",
                              },
                            },
                            _vm._l(_vm.StateList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.label, value: item.label },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.LanShouSite"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.OnlyAreDisplayed"
                                ),
                                "remote-method": _vm.remoteGetSiteList,
                                clearable: "",
                                filterable: "",
                                remote: "",
                                "reserve-keyword": "",
                                size: "small",
                              },
                              on: {
                                focus: function ($event) {
                                  return _vm.remoteGetSiteList("")
                                },
                              },
                              model: {
                                value: _vm.queryForm.params.collectStationId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "collectStationId",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.collectStationId",
                              },
                            },
                            _vm._l(_vm.siteList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("GlobalSetObj.preEntrega") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.OnlyAreDisplayed"
                                ),
                                "remote-method": _vm.remoteGetSiteList,
                                clearable: "",
                                filterable: "",
                                remote: "",
                                "reserve-keyword": "",
                                size: "small",
                              },
                              on: {
                                focus: function ($event) {
                                  return _vm.remoteGetSiteList("")
                                },
                              },
                              model: {
                                value: _vm.queryForm.params.preDeliverStationId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "preDeliverStationId",
                                    $$v
                                  )
                                },
                                expression:
                                  "queryForm.params.preDeliverStationId",
                              },
                            },
                            _vm._l(_vm.siteList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("GlobalSetObj.entrega") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.OnlyAreDisplayed"
                                ),
                                "remote-method": _vm.remoteGetSiteList,
                                clearable: "",
                                filterable: "",
                                remote: "",
                                "reserve-keyword": "",
                                size: "small",
                              },
                              on: {
                                focus: function ($event) {
                                  return _vm.remoteGetSiteList("")
                                },
                              },
                              model: {
                                value: _vm.queryForm.params.deliverStationId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "deliverStationId",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.deliverStationId",
                              },
                            },
                            _vm._l(_vm.siteList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "collectionCenter.deliveryRegionType"
                            ),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("GlobalSetObj.all"),
                                clearable: "",
                                "collapse-tags": "",
                                filterable: "",
                                size: "small",
                              },
                              model: {
                                value: _vm.queryForm.params.deliveryAreaType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "deliveryAreaType",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.deliveryAreaType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("newOrder.all"),
                                  value: null,
                                },
                              }),
                              _c("el-option", {
                                attrs: { label: "CAP", value: "CAP" },
                              }),
                              _c("el-option", {
                                attrs: { label: "INT", value: "INT" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("home.PaymentCertificate") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("GlobalSetObj.all"),
                                clearable: "",
                                "collapse-tags": "",
                                filterable: "",
                                size: "small",
                              },
                              model: {
                                value: _vm.queryForm.params.paymentVoucher,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "paymentVoucher",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.paymentVoucher",
                              },
                            },
                            [
                              _c("el-option", {
                                key: 0,
                                attrs: {
                                  label: _vm.$t("newOrder.all"),
                                  value: null,
                                },
                              }),
                              _c("el-option", {
                                key: 1,
                                attrs: {
                                  label: _vm.$t("customerManagements.approved"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                key: 2,
                                attrs: {
                                  label: _vm.$t("orderCenterCont.ReviewFailed"),
                                  value: 2,
                                },
                              }),
                              _c("el-option", {
                                key: 3,
                                attrs: {
                                  label: _vm.$t("orderCenterCont.NotUploaded"),
                                  value: 3,
                                },
                              }),
                              _c("el-option", {
                                key: 4,
                                attrs: {
                                  label: _vm.$t(
                                    "orderCenterCont.FinancialPendingReview"
                                  ),
                                  value: 4,
                                },
                              }),
                              _c("el-option", {
                                key: 5,
                                attrs: {
                                  label: _vm.$t(
                                    "orderCenterCont.PleaseUploadAgain"
                                  ),
                                  value: 5,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "searchTimeType" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selectClass",
                                  style: _vm.IsWidthTime,
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                    size: "small",
                                  },
                                  on: { change: _vm.changeTimeType },
                                  model: {
                                    value: _vm.queryForm.params.searchTimeType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "searchTimeType",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "queryForm.params.searchTimeType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    key: "1",
                                    attrs: {
                                      label: _vm.$t("GlobalSetObj.TimeOfOrder"),
                                      value: "1",
                                    },
                                  }),
                                  _c("el-option", {
                                    key: "1",
                                    attrs: {
                                      label: _vm.$t("collectionCenter.signT"),
                                      value: "2",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "default-time": ["00:00:00", "23:59:59"],
                              "end-placeholder": _vm.$t(
                                "operationCenter.endDate"
                              ),
                              format:
                                _vm.$i18n.locale === "zh"
                                  ? _vm.zhDate
                                  : _vm.ptDate,
                              "start-placeholder": _vm.$t(
                                "operationCenter.startDate"
                              ),
                              "range-separator": "~",
                              size: "small",
                              type: "datetimerange",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            on: { change: _vm.changeTime },
                            model: {
                              value: _vm.timeValue,
                              callback: function ($$v) {
                                _vm.timeValue = $$v
                              },
                              expression: "timeValue",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selectClass",
                                  style: _vm.IsWidth,
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "orderDetails.pleaseChoose"
                                    ),
                                    size: "small",
                                  },
                                  model: {
                                    value:
                                      _vm.queryForm.params.searchNumberType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "searchNumberType",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "queryForm.params.searchNumberType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    key: "1",
                                    attrs: {
                                      label: _vm.$t("navbar.anjunOrderNumber"),
                                      value: "1",
                                    },
                                  }),
                                  _c("el-option", {
                                    key: "2",
                                    attrs: {
                                      label: _vm.$t(
                                        "orderCenterCont.anjunWaybillNumber"
                                      ),
                                      value: "2",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "100%",
                                "margin-top": "5px",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "newOrder.PreciseSearch2"
                                  ),
                                  rows: 2,
                                  size: "small",
                                  type: "textarea",
                                },
                                model: {
                                  value: _vm.queryForm.params.searchNumberStr,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm.params,
                                      "searchNumberStr",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "queryForm.params.searchNumberStr",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c(
                      "div",
                      {
                        staticClass: "flx-between",
                        staticStyle: { "margin-bottom": "10px" },
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "small", type: "primary" },
                                on: { click: _vm.enterGetSearch },
                              },
                              [_vm._v(_vm._s(_vm.$t("newOrder.search")) + " ")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { size: "small", type: "info" },
                                on: { click: _vm.resetData },
                              },
                              [_vm._v(_vm._s(_vm.$t("newOrder.reset")) + " ")]
                            ),
                            _c(
                              "el-radio-group",
                              {
                                staticStyle: { "margin-left": "10px" },
                                attrs: { size: "small" },
                                on: { change: _vm.enterGetSearch },
                                model: {
                                  value: _vm.queryForm.params.orderWaybillType,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm.params,
                                      "orderWaybillType",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "queryForm.params.orderWaybillType",
                                },
                              },
                              [
                                _c("el-radio-button", { attrs: { label: 1 } }, [
                                  _vm._v(_vm._s(_vm.$t("newOrder.Formal"))),
                                ]),
                                _c("el-radio-button", { attrs: { label: 2 } }, [
                                  _vm._v(_vm._s(_vm.$t("newOrder.test1"))),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _c(
                              "el-popover",
                              {
                                staticStyle: { "margin-right": "15px" },
                                attrs: {
                                  placement: "bottom",
                                  trigger: "hover",
                                },
                              },
                              [
                                _c("div", [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: { "margin-bottom": "10px" },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            size: "small",
                                          },
                                          on: { click: _vm.openModifyWindow },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "collectionCenter.ModifyDeliveryMethod"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: { "margin-bottom": "10px" },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "permit",
                                              rawName: "v-permit:remove",
                                              value:
                                                "btn:logisticsOrders:largeRecipientAddress",
                                              expression:
                                                "'btn:logisticsOrders:largeRecipientAddress'",
                                              arg: "remove",
                                            },
                                          ],
                                          attrs: {
                                            size: "small",
                                            type: "primary",
                                          },
                                          on: { click: _vm.recipientAddress },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "GlobalSetObj.fixaddress"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "text-align": "center",
                                        "margin-bottom": "10px",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-popconfirm",
                                        {
                                          attrs: {
                                            "hide-icon": true,
                                            title: _vm.$t(
                                              "GlobalSetObj.cancelOrderSure"
                                            ),
                                          },
                                          on: { confirm: _vm.cancelOrder },
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              directives: [
                                                {
                                                  name: "permit",
                                                  rawName: "v-permit:remove",
                                                  value:
                                                    "btn:logisticsOrders:largeCancelOrder",
                                                  expression:
                                                    "'btn:logisticsOrders:largeCancelOrder'",
                                                  arg: "remove",
                                                },
                                              ],
                                              attrs: {
                                                slot: "reference",
                                                size: "small",
                                                type: "primary",
                                              },
                                              slot: "reference",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "collectionCenter.largeOrderCancel"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: { "margin-bottom": "10px" },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "permit",
                                              rawName: "v-permit:remove",
                                              value:
                                                "btn:logisticsOrders:orderInfoExport",
                                              expression:
                                                "'btn:logisticsOrders:orderInfoExport'",
                                              arg: "remove",
                                            },
                                          ],
                                          attrs: {
                                            size: "small",
                                            type: "success",
                                          },
                                          on: { click: _vm.allExportOrder },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "collectionCenter.orderInformationExport"
                                              )
                                            ) + " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: { "margin-bottom": "10px" },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "permit",
                                              rawName: "v-permit:remove",
                                              value:
                                                "btn:logisticsOrders:waybillInfoExport",
                                              expression:
                                                "'btn:logisticsOrders:waybillInfoExport'",
                                              arg: "remove",
                                            },
                                          ],
                                          attrs: {
                                            size: "small",
                                            type: "success",
                                          },
                                          on: { click: _vm.waybillInfoExport },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "collectionCenter.waybillInformationExport"
                                              )
                                            ) + " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "permit",
                                          rawName: "v-permit:remove",
                                          value:
                                            "btn:logisticsOrders:abnormalPackageMark",
                                          expression:
                                            "'btn:logisticsOrders:abnormalPackageMark'",
                                          arg: "remove",
                                        },
                                      ],
                                      staticStyle: { "margin-bottom": "10px" },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "small",
                                            type: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.abnormalPackageMark()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "collectionCenter.AbnormalPackageMark"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "10px" },
                                    attrs: {
                                      slot: "reference",
                                      size: "small",
                                      type: "primary",
                                    },
                                    slot: "reference",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("orderCenterCont.moreActions")
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "tableDataRef",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": { background: "#f2f2f2", color: "black" },
            border: "",
            "max-height": "600",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: { fixed: "left", type: "selection", width: "55" },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.serial"),
              align: "center",
              fixed: "left",
              type: "index",
              width: "80",
            },
          }),
          _vm._l(_vm.tableHeaderList, function (item) {
            return _c("el-table-column", {
              key: item.id,
              attrs: {
                align: item.center,
                label: item.label,
                "min-width": item.cloWidth,
                prop: item.prop,
                "show-overflow-tooltip": false,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        item.prop === "orderNumber"
                          ? _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass: "textOrder",
                                  on: {
                                    click: function ($event) {
                                      return _vm.toDetail(scope.row, "xq")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(scope.row.orderNumber) + " "
                                  ),
                                ]
                              ),
                            ])
                          : item.prop === "paymentVoucher"
                          ? _c("div", [
                              scope.row[item.prop] === 1
                                ? _c(
                                    "div",
                                    { staticStyle: { color: "#409eff" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "customerManagements.approved"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : scope.row[item.prop] === 2
                                ? _c(
                                    "div",
                                    { staticStyle: { color: "#f00" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "orderCenterCont.ReviewFailed"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : scope.row[item.prop] === 3
                                ? _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("orderCenterCont.NotUploaded")
                                        ) +
                                        " "
                                    ),
                                  ])
                                : scope.row[item.prop] === 4
                                ? _c(
                                    "div",
                                    { staticStyle: { color: "#f00" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "orderCenterCont.FinancialPendingReview"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : scope.row[item.prop] === 5
                                ? _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "orderCenterCont.PleaseUploadAgain"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ])
                                : scope.row[item.prop] === 6
                                ? _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "orderCenterCont.NoUploadRequired"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                            ])
                          : item.prop === "waybillList"
                          ? _c("div", [
                              scope.row.showWaybill === false
                                ? _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "textOrder",
                                        on: {
                                          click: function ($event) {
                                            return _vm.toDetail(scope.row, "gj")
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(scope.row.waybillList[0]) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    scope.row.waybillList.length > 1
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "textOrder",
                                            on: {
                                              click: function ($event) {
                                                scope.row.showWaybill = true
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " ..." +
                                                _vm._s(
                                                  _vm.$t(
                                                    "orderCenterCont.expand"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ])
                                : _c(
                                    "div",
                                    _vm._l(
                                      scope.row[item.prop],
                                      function (items, index) {
                                        return _c("div", { key: index }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "textOrder",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toDetail(
                                                    scope.row,
                                                    "gj"
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(items))]
                                          ),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                            ])
                          : item.prop === "totalFee"
                          ? _c("div", [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function ($event) {
                                      _vm.checkClick(
                                        (_vm.queryForm.pageNumber - 1) *
                                          _vm.queryForm.pageSize +
                                          scope.$index +
                                          1
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm.checkIndex ==
                                    (_vm.queryForm.pageNumber - 1) *
                                      _vm.queryForm.pageSize +
                                      scope.$index +
                                      1 && _vm.isCheckThis
                                    ? _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(scope.row[item.prop]) +
                                            " "
                                        ),
                                      ])
                                    : _c("span", [_vm._v("*** ")]),
                                  _c("span", { staticClass: "isFindClass" }, [
                                    _vm.checkIndex ==
                                      (_vm.queryForm.pageNumber - 1) *
                                        _vm.queryForm.pageSize +
                                        scope.$index +
                                        1 && _vm.isCheckThis
                                      ? _c("i", { staticClass: "el-icon-view" })
                                      : _c("i", [
                                          _c("img", {
                                            staticStyle: {
                                              width: "12px",
                                              height: "10px",
                                            },
                                            attrs: {
                                              src: _vm.closeEyes,
                                              alt: "",
                                            },
                                          }),
                                        ]),
                                  ]),
                                ]
                              ),
                            ])
                          : item.prop === "abnormalWaybillList"
                          ? _c("div", [
                              scope.row.showAbnormal === false
                                ? _c("div", [
                                    _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            scope.row.abnormalWaybillList[0]
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    scope.row.abnormalWaybillList.length > 1
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "textOrder",
                                            on: {
                                              click: function ($event) {
                                                scope.row.showAbnormal = true
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " ..." +
                                                _vm._s(
                                                  _vm.$t(
                                                    "orderCenterCont.expand"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ])
                                : _c(
                                    "div",
                                    _vm._l(
                                      scope.row.abnormalWaybillList,
                                      function (items, index) {
                                        return _c("div", { key: index }, [
                                          _c("div", [_vm._v(_vm._s(items))]),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                            ])
                          : item.prop === "delivererName"
                          ? _c("div", [
                              scope.row.showDeliverer === false
                                ? _c("div", [
                                    _c("div", [
                                      _vm._v(
                                        " " +
                                          _vm._s(scope.row.delivererList[0]) +
                                          " "
                                      ),
                                    ]),
                                    scope.row.delivererList.length > 1
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "textOrder",
                                            on: {
                                              click: function ($event) {
                                                scope.row.showDeliverer = true
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " ..." +
                                                _vm._s(
                                                  _vm.$t(
                                                    "orderCenterCont.expand"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ])
                                : _c(
                                    "div",
                                    _vm._l(
                                      scope.row.delivererList,
                                      function (items, index) {
                                        return _c("div", { key: index }, [
                                          _c("div", [_vm._v(_vm._s(items))]),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                            ])
                          : _c("div", [
                              _vm._v(
                                _vm._s(
                                  scope.row[item.prop]
                                    ? "" + scope.row[item.prop]
                                    : "--"
                                )
                              ),
                            ]),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("newOrder.operation"),
              align: "center",
              fixed: "right",
              width: "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-around",
                          "align-items": "center",
                        },
                      },
                      [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              content: _vm.$t("GlobalSetObj.details"),
                              effect: "dark",
                              placement: "top",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "iconfont icon-chakan textOperator",
                              on: {
                                click: function ($event) {
                                  return _vm.toDetail(scope.row, "xq")
                                },
                              },
                            }),
                          ]
                        ),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              content: _vm.$t("GlobalSetObj.TrackSearch"),
                              effect: "dark",
                              placement: "top",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "iconfont icon-a-zu231 textOperator",
                              staticStyle: { "margin-left": "10px" },
                              on: {
                                click: function ($event) {
                                  return _vm.toDetail(scope.row, "gj")
                                },
                              },
                            }),
                          ]
                        ),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              content: _vm.$t("newOrder.orderNote"),
                              effect: "dark",
                              placement: "top",
                            },
                          },
                          [
                            _c("span", {
                              staticClass: "el-icon-edit textOperator",
                              staticStyle: { "margin-left": "10px" },
                              on: {
                                click: function ($event) {
                                  return _vm.toRemarks(scope.row)
                                },
                              },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        2
      ),
      _c("el-pagination", {
        staticStyle: { margin: "20px 0", "text-align": "right" },
        attrs: {
          "current-page": _vm.queryForm.pageNumber,
          "page-size": _vm.queryForm.pageSize,
          "page-sizes": [10, 50, 100, 200, 400],
          total: _vm.queryForm.total,
          background: "",
          layout: "total, sizes, prev, pager, next, jumper",
        },
        on: {
          "update:currentPage": function ($event) {
            return _vm.$set(_vm.queryForm, "pageNumber", $event)
          },
          "update:current-page": function ($event) {
            return _vm.$set(_vm.queryForm, "pageNumber", $event)
          },
          "update:pageSize": function ($event) {
            return _vm.$set(_vm.queryForm, "pageSize", $event)
          },
          "update:page-size": function ($event) {
            return _vm.$set(_vm.queryForm, "pageSize", $event)
          },
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c(
        "el-drawer",
        {
          attrs: {
            "append-to-body": true,
            visible: _vm.detailDialog,
            "custom-class": "drawerClass",
            direction: "ltr",
            size: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailDialog = $event
            },
            close: _vm.handledetailDialog,
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function () {
                return [
                  _c("div", [
                    _c("span", { staticStyle: { "margin-right": "20px" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("collectionCenter.largeOrderDetails"))
                      ),
                    ]),
                    _c("span", { staticStyle: { "margin-right": "10px" } }, [
                      _vm._v(
                        " " + _vm._s("" + _vm.detailDialogObj.orderNumber)
                      ),
                    ]),
                    _c("span", [
                      _vm._v(
                        "(" +
                          _vm._s(_vm.$t("navbar.gong")) +
                          " " +
                          _vm._s(_vm.detailDialogObj.totalNumber) +
                          " " +
                          _vm._s(_vm.$t("navbar.jian")) +
                          ")"
                      ),
                    ]),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("Detail", {
            key: _vm.keyChange,
            ref: "Detail",
            attrs: {
              grandson: _vm.DetailId,
              "open-idx": _vm.openType,
              "remark-id": _vm.form.orderId,
              "waybill-list": _vm.waybillList,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.remarksClose,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("collectionCenter.Note"),
            visible: _vm.remarksDialogVisible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.remarksDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "remarksRef",
              staticClass: "remarks_class",
              attrs: { model: _vm.form },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            rules: {
                              required: true,
                              message: _vm.$t(
                                "collectionCenter.pleaseEnterRemarks"
                              ),
                              trigger: ["change"],
                            },
                            prop: "remark",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "collectionCenter.inputPrompt"
                              ),
                              clearable: "",
                              maxlength: "200",
                              "show-word-limit": "",
                              type: "textarea",
                            },
                            model: {
                              value: _vm.form.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "remark", $$v)
                              },
                              expression: "form.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitRemark } },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("collectionCenter.ModifyDeliveryMethod"),
            visible: _vm.showModifyWindow,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showModifyWindow = $event
            },
            close: _vm.closeModifyWindow,
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "30px" } },
            [
              _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("GlobalSetObj.Selecionadas")) +
                    "：" +
                    _vm._s(_vm.selectionList.length) +
                    " "
                ),
              ]),
              _c(
                "el-form",
                {
                  ref: "modifyDeliveryMethod",
                  staticClass: "remarks_class",
                  attrs: {
                    model: _vm.modifyForm,
                    "label-position": "top",
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "collectionCenter.ModifyDeliveryMethod"
                                ),
                                rules: {
                                  required: true,
                                  message: _vm.$t("collectionCenter.notNull"),
                                  trigger: ["change"],
                                },
                                prop: "deliveryMethod",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "collectionCenter.pleaseChoose"
                                    ),
                                  },
                                  model: {
                                    value: _vm.modifyForm.deliveryMethod,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.modifyForm,
                                        "deliveryMethod",
                                        $$v
                                      )
                                    },
                                    expression: "modifyForm.deliveryMethod",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    key: 1,
                                    attrs: {
                                      label: _vm.$t(
                                        "collectionCenter.HoldForCompleteDelivery"
                                      ),
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    key: 2,
                                    attrs: {
                                      label: _vm.$t(
                                        "collectionCenter.firstComeFirstServeDelivery"
                                      ),
                                      value: 2,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: { click: _vm.closeModifyWindow },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.submitModifyForm },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.confirm")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false,
            title: _vm.$t("collectionCenter.tips"),
            visible: _vm.showModifyWindowResult,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showModifyWindowResult = $event
            },
          },
        },
        [
          _c("div", [
            _c(
              "div",
              {
                staticStyle: { "margin-bottom": "20px", "font-weight": "bold" },
              },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("newOrder.OperationSuccessful")) + "！ "
                ),
              ]
            ),
            _c(
              "div",
              { staticStyle: { display: "flex", "margin-bottom": "20px" } },
              [
                _c("div", { staticStyle: { width: "140px" } }, [
                  _vm._v(
                    _vm._s(_vm.$t("newOrder.all")) +
                      "：" +
                      _vm._s(_vm.modifyResult.all)
                  ),
                ]),
                _c("div", { staticStyle: { flex: "1" } }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("newOrder.TheUpdateWasSuccessful")) +
                      "：" +
                      _vm._s(_vm.modifyResult.success) +
                      " "
                  ),
                ]),
                _c("div", { staticStyle: { flex: "1" } }, [
                  _vm._v(
                    _vm._s(_vm.$t("newOrder.TheUpdateFailed")) +
                      "：" +
                      _vm._s(_vm.modifyResult.fail)
                  ),
                ]),
              ]
            ),
            _vm.modifyResult.errorList.length > 0
              ? _c(
                  "div",
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-bottom": "10px",
                          "font-weight": "bold",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("GlobalSetObj.ReasonForFailure")) +
                            "： "
                        ),
                      ]
                    ),
                    _vm._l(_vm.modifyResult.errorList, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticStyle: { "margin-bottom": "10px" },
                        },
                        [_vm._v(" " + _vm._s(item) + " ")]
                      )
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.closeModifyResult },
                },
                [_vm._v(_vm._s(_vm.$t("orderExport.close")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            "close-on-click-modal": false,
            "show-close": true,
            title: _vm.$t("GlobalSetObj.fixaddress"),
            visible: _vm.fixAddress,
            top: "5vh",
            width: "900px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.fixAddress = $event
            },
            close: _vm.clearForm,
          },
        },
        [
          _c("edit-recipient-information", {
            key: _vm.fixAddress,
            ref: "editRecipientInformationRef",
            attrs: {
              "recevice-rule-form": _vm.receviceRuleForm,
              "sender-state-list": _vm.senderStateList,
              "selection-list": _vm.selectionList,
              "old-zip-code": _vm.oldZipCode,
              "change-type": 2,
            },
            on: { updateTable: _vm.updateTableData },
          }),
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.fixAddress = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.Cancelar")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.comfireFixAddress },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.determine")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("GlobalSetObj.tips"),
            visible: _vm.tipDialog,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.tipDialog = $event
            },
          },
        },
        [
          _c(
            "el-row",
            {
              staticStyle: { "font-size": "16px !important" },
              attrs: { gutter: 10 },
            },
            [
              _c("el-col", { attrs: { span: 8 } }, [
                _vm._v(_vm._s(_vm.$t("GlobalSetObj.fixTotal")) + ":"),
                _c("span", { staticClass: "tipclass" }, [
                  _vm._v(_vm._s(_vm.tipDialogData.updateTotal)),
                ]),
              ]),
              _c("el-col", { attrs: { span: 8 } }, [
                _vm._v(
                  _vm._s(_vm.$t("GlobalSetObj.ModificationSuccessful")) + ":"
                ),
                _c("span", { staticClass: "tipclass" }, [
                  _vm._v(_vm._s(_vm.tipDialogData.successTotal)),
                ]),
              ]),
              _c("el-col", { attrs: { span: 8 } }, [
                _vm._v(_vm._s(_vm.$t("GlobalSetObj.failTotal")) + ":"),
                _c(
                  "span",
                  { staticClass: "tipclass", staticStyle: { color: "red" } },
                  [_vm._v(_vm._s(_vm.tipDialogData.failTotal))]
                ),
              ]),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                "margin-top": "20px",
                "font-size": "16px",
                "line-height": "30px",
                height: "200px",
                "overflow-y": "auto",
              },
            },
            [
              _vm.tipDialogData.failTotal
                ? _c(
                    "div",
                    [
                      _c("div", [
                        _vm._v(_vm._s(_vm.$t("GlobalSetObj.notFix")) + ":"),
                      ]),
                      _vm._l(
                        _vm.tipDialogData.errorList,
                        function (item, index) {
                          return _c("div", { key: index }, [
                            _c("span", [_vm._v(_vm._s(index + 1) + ".")]),
                            _c("span", [_vm._v(_vm._s(item.waybillNumber))]),
                            _c(
                              "span",
                              { staticStyle: { "margin-left": "10px" } },
                              [_vm._v(_vm._s(item.errorMessage))]
                            ),
                          ])
                        }
                      ),
                    ],
                    2
                  )
                : _vm._e(),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "center", margin: "15px 0" } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.tipDialog = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.determine")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("collectionCenter.AbnormalPackageMark"),
            visible: _vm.showAbnormalPackageMarkWindow,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showAbnormalPackageMarkWindow = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("abnormal-package-mark", {
                key: _vm.showAbnormalPackageMarkWindow,
                ref: "abnormalPackageMarkRef",
                on: { updateTable: _vm.updateTableAbnormal },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("collectionCenter.largeOrderCancel"),
            visible: _vm.coDialog,
            width: "550px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.coDialog = $event
            },
            close: _vm.clearProgress,
          },
        },
        [
          _c(
            "div",
            [
              _c("el-progress", {
                class: _vm.coProgress === 100 ? "is-success" : "",
                staticStyle: { margin: "20px 0 10px" },
                attrs: {
                  percentage: 100,
                  format: _vm.formatProgress,
                  "stroke-width": 10,
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _c("sapn", [
                _vm._v(_vm._s(_vm.$t("operationCenter.succeed")) + "："),
                _c("span", { staticStyle: { color: "#61ceae" } }, [
                  _vm._v(_vm._s(_vm.coList.successCount || 0)),
                ]),
              ]),
              _c("sapn", { staticStyle: { "margin-left": "30px" } }, [
                _vm._v(_vm._s(_vm.$t("operationCenter.fail")) + "："),
                _c("span", { staticStyle: { color: "#cc3b3b" } }, [
                  _vm._v(_vm._s(_vm.coList.failuresCount || 0)),
                ]),
              ]),
            ],
            1
          ),
          _vm.coList.failuresMap &&
          Object.keys(_vm.coList.failuresMap).length > 0
            ? _c(
                "div",
                [
                  _c("span", { staticStyle: { display: "inline-block" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("collectionCenter.failureDetails")) + "："
                    ),
                  ]),
                  _vm._l(
                    _vm.coList.failuresMap,
                    function (errorMessage, waybillNumber) {
                      return _c("div", { key: waybillNumber }, [
                        _vm._v(" " + _vm._s(waybillNumber) + "："),
                        _c("span", { staticStyle: { color: "black" } }, [
                          _vm._v(_vm._s(errorMessage)),
                        ]),
                      ])
                    }
                  ),
                ],
                2
              )
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.clearProgress } },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.close")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }